import { createAction, props } from '@ngrx/store';
// import { BloodBank } from 'src/models/module-wise/user/patient';

// TODO: Add Interface

export const paginateBloodBanks = createAction(
  '[ BloodBank ] Paginating'
);

export const loadBloodBanks = createAction(
  '[ BloodBank ] Load BloodBank',
  props<{ payload: any[], totalDocuments: number }>()
);

export const editBloodBank = createAction(
  '[ BloodBank ] Edit BloodBank',
  props<{ payload: any | { status: string, _id: string } }>()
);

export const removeBloodBanks = createAction(
  '[ BloodBank ] Delete BloodBank',
  props<{ payload: string[] }>()
);

export const removeAllBloodBanks = createAction(
  '[ BloodBank ] Remove All BloodBank'
);
